module.exports = __webpack_public_path__ + "static/img/s.7815384.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/s.png
// module id = 1xOH
// module chunks = 53